/**
 * Based on SC Image Carousel
 * Loop for all carousels on the DOM and assign the proper setup for the section carousel
 */
const carouselArray = document.querySelectorAll('.carousel');

carouselArray.forEach((item) => {
    // console.log(item.getAttribute('data-custompagination')); //- 'true' : 'false'
    // console.log(item.dataset.custompagination); //- 'true' : 'false'

    let myCarousel = item.childNodes[0].className;
    let myCarouselParent = item.getAttribute('id');

    // console.log(myCarouselParent);

    if (item.getAttribute('data-custompagination') == 'true') {
        // console.log("yes", item);

        $('#' + myCarouselParent + ' .' + myCarousel).slick({
            slidesToShow: parseInt(item.dataset.slidestoshow),
            slidesToScroll: parseInt(item.dataset.slidestoscroll),
            infinite: item.dataset.infinite == 'true' ? true : false,
            autoplay: item.dataset.autoplay == 'true' ? true : false,
            autoplaySpeed: parseInt(item.dataset.autoplayspeed),
            speed: parseInt(item.dataset.changeslidespeed),
            dots: item.dataset.showdots == 'true' ? true : false,
            arrows: item.dataset.showarrows == 'true' ? true : false,
            appendDots: $(".carousel__customNav"),
            customPaging: function (slick, i) {
                let targetImage = $(slick.$slides[i]).data('img'),
                    targetAlt = $(slick.$slides[i]).data('alt');
                return '<img data-src="' + targetImage + '" alt="' + targetAlt + '" class="carousel__customNavImg lazyload"/>';
            }
        });

    } else {
        // console.log("no", item);

        $('#' + myCarouselParent + ' .' + myCarousel).slick({
            slidesToShow: parseInt(item.dataset.slidestoshow),
            slidesToScroll: parseInt(item.dataset.slidestoscroll),
            infinite: item.dataset.infinite == 'true' ? true : false,
            autoplay: item.dataset.autoplay == 'true' ? true : false,
            autoplaySpeed: parseInt(item.dataset.autoplayspeed),
            speed: parseInt(item.dataset.changeslidespeed),
            dots: item.dataset.showdots == 'true' ? true : false,
            arrows: item.dataset.showarrows
        });
    }
});